const retailItineraryFragment = `
  ... on AirListingsRtlItinerary {
    isExchangeFlight
    id
    itemKey
    priceKey
    hasRecommendedBundleProposal
    seatsAvailable
    isFused
    isBEC
    listingPosition
    fareBrands {
      priceKey
      isSelected
      ancillaryInclusionInfo
      pricing {
        amount
        text
        amountInFloat
        dollar
        cents
      }
      name
      ancillaries {
        name
        description
        tag
        offerType
        coreAttribute
      }
      price {
        type
        amount
        dollar
        cents
        strikeThroughInfo {
          strikeThroughPerPerson
          savings {
            amount
            inPercent
            inDollars
            inCents
          }
        }
        packagesPriceData {
          totalCost
          displayTotalCost
          totalCostWithHotelMandatoryFees
          totalPayNow
          totalPayLater
          totalSavings
          displayTotalSavings
          totalStrikethrough
          displayTotalStrikethrough
          totalCostPerTraveler
          displayPerPersonCost
          originalCostPerTraveler
          totalHotelMandatoryFees
          roomMandatoryFees
          perPersonSavings
          totalCostPerTravelerWithFees
        }
      }
      seatsAvailable
      seatsAvailableText
      fareType
      legroom
    }
    price {
      type
      currencyCode
      currencySymbol
      amount
      dollar
      cents
      creditSummary {
        creditAvailable
        creditApplied
        forfeitAmount
        changeFee
      }
      packagesPriceData {
        totalCost
        totalCostWithHotelMandatoryFees
        totalPayNow
        totalPayLater
        totalSavings
        displayTotalSavings
        totalStrikethrough
        totalCostPerTraveler
        originalCostPerTraveler
        totalHotelMandatoryFees
        roomMandatoryFees
        perPersonSavings
        totalCostPerTravelerWithFees
      }
    }
    allFareBrandNames
    marketingAirlines {
      code
      name
      image
    }
    airlines {
      marketingAirline
      name
      code
      image
    }
    slices {
      id
      merchandisingBadges {
        title
        colorScheme
      }
      sliceKey
      duration
      durationInMinutes
      stops
      isOvernight
      overnightDays
      displayText {
        operatedByText
        carrierText
      }
      departInfo {
        airport {
          code
          name
          isoCountryCode
          displayLocation
        }
        time {
          dateTime
          displayTime
          displayDate
        }
      }
      arrivalInfo {
        airport {
          code
          name
          isoCountryCode
          displayLocation
        }
        time {
          dateTime
          displayTime
          displayDate
        }
      }
      layoverInfo {
        id
        duration
        airport {
          code
          name
        }
      }
      segments {
        stopQuantity
        isOvernight
        seatsAvailable
        equipment
        id
        marketingAirline
        operatingAirline
        displayText {
          operatedByText
        }
        flightNumber
        formattedDate
        cabinClass
        isBEC
        duration
        isSubjectToGovtApproval
        departInfo {
          airport {
            code
            name
          }
          time {
            dateTime
            displayTime
            displayDate
          }
        }
        arrivalInfo {
          airport {
            code
            name
          }
          time {
            dateTime
            displayTime
            displayDate
          }
        }
      }
    }
    voidWindowInfo {
      timeStamp
      tzDesignator
      cancelTimeZone
      clientUTCDateTime
      hoursLeft
    }
    totalPriceWithDecimal {
      dollar
      cents
      price
    }
    operatedByAirlines {
      flightNumber
      airline
    }
    proposalComponents {
      type
      itemKey
      priceKey
      componentKey
      componentIndex
      hotelId
      hotelStarRating
    }
    pricingMerchandisings {
      value
      colorScheme
      key
    }
  }
`

const expressDealFragment = `
  ... on AirExpressDealsCandidates {
    isExpressDeal
    isFused
    id: exID
    itemKey
    priceKey
    sameDayDepartHoursBeforeTravel
    sameDayDepartMinsBeforeTravelDial
    tripType
    listingPosition
    exdOpenJaw: openJaw
    budgetSaver {
      tag
      longCopy
      shortCopy
    }
    totalPriceWithDecimal {
      dollar
      cents
      price
    }
    price {
      type
      currencyCode
      currencySymbol
      amount
      dollar
      cents
    }

    fareBrands {
      price {
        type
        amount
      }
    }
    slice {
      id
      sliceKey
      stopsText
      maximumStops
      cabinClass
      mayArriveNextDay
      carryOnBagAllowed
      checkedBagAllowed
      carryOnBagOption
      allowedEquipment
      arrivalText
      partOfDay
      ancillaries {
        name
        inclusion
        description
      }
      arrivalWindow {
        start
        end
        exclusionStart
        exclusionEnd
      }
      departureWindow {
        start
        end
        exclusionStart
        exclusionEnd
        timeRange
      }
      origin {
        code
        openJawCopy
      }
      destination {
        code
        openJawCopy
      }
      alternateOriginAirport
      alternateDestinationAirport
    }
    pricingInfo {
      currencyCode
      totalFare: totalTripCost
      comparativeRetailPrice
      savings {
        inPercent
        inDollars
      }
    }
    pricingMerchandisings {
      value
      colorScheme
    }
  }
`

const searchRespQuery = `
  airline {
    code
    name
    smallImage
  }
  airport {
    code
    name
    city
    isoCountryCode
    state
    country
  }
  listingsMetaData {
    searchSessionKey
    requestId
    hasExpressDeal
    minimumRetailPrice
    minimumListingPrice
    nonStopPrice
    tripType
    lowerBound
    upperBound
    totalItineraries
    totalFilteredItineraries
    latencyHit
    selectedPackagePrice
    isProposalPricingMissing
    creditAvailableSummary {
      creditAvailable
      airlineName
      changeFee
    }
  }
  error {
    code
    desc
    message
    status
		reason
		reason_code
  }
  displayableCarriers

  listings {
    ${expressDealFragment}
    ${retailItineraryFragment}
  }

  recommendedListings {
    ${expressDealFragment}
    ${retailItineraryFragment}
  }

  filterDefaults {
    SORT_OPTIONS {
      primaryLabel
      value
      isSelected
    }

    DEFAULT_TAB_ITEMS {
      label
      name
    }
    NUM_OF_STOPS {
      primaryLabel
      value
      checked
      secondaryLabel
      wrapLabel
      disabled
      count
    }
    AIRLINES {
      value
      primaryLabel
      secondaryLabel
      checked
      disabled
      count
    }
    AIRPORTS {
      originAirports {
        value
        primaryLabel
        disabled
        checked
        secondaryLabel
        minPrice
        count
      }

      destinationAirports {
        value
        primaryLabel
        disabled
        checked
        secondaryLabel
        minPrice
        count
      }
    }
    TIME {
      sliceRefId
      destinationCode
      originCode
      categories {
        takeoff {
          timebands {
            icon
            label
            timeRange
            disable
          }
        }
        landing {
          timebands {
            icon
            label
            timeRange
            disable
          }
        }
      }
    }
    DATE {
      value
      primaryLabel
      secondaryLabel
      checked
      disabled
      wrapLabel
      isExact
    }
    SLICE_ARRAY {
      sliceRefId
      minDuration
      maxDuration
      minTakeoffTime
      maxTakeoffTime
      minLandingTime
      maxLandingTime
    }
    ATTRIBUTES {
      value
      checked
      disabled
      primaryLabel
    }
  }
  hasAppInstalled

`

export const airSearchRespQuery = `
  query airSearchResp($input: AirSearchReq) {
    airSearchResp(input: $input) {
      ${searchRespQuery}
    }
  }
`
